/**
 * A Path2D's tessellated curve for its PathFollow2D descendants, whatever the
 * selection. A curveless Path2D provides `null`, so PathFollow2D keeps its
 * authored transform. The sampler gives Path2D-local pixels, +Y down, which
 * PathFollow2D conjugates (negated Y and rotation).
 */
import { createContext, useContext } from 'react';
const Path2DCurveContext = createContext(null);
Path2DCurveContext.displayName = 'Path2DCurveContext';
export const Path2DCurveProvider = Path2DCurveContext.Provider;
/** The nearest ancestor Path2D's curve sampler, or null when there is none. */
export function useParentPath2DCurve() {
    return useContext(Path2DCurveContext);
}
//# sourceMappingURL=Path2DCurveContext.js.map